import { SectionTitle } from "@/components/common/SectionTitle";
import ticketIcon from "@/assets/icons/sell.svg";
import PortCard from "@/features/purchase-ticket/PortCard";
import { useEffect } from "react";
import { useContactStore } from "@/stores/contact.store";

export default function PurchaseTicketPage() {
  const clearContact = useContactStore((state) => state.clearContact);

  useEffect(() => {
    clearContact();
  }, [clearContact]);
  
  return (
    <div className="max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between">
        <SectionTitle img={ticketIcon} title="Purchase Ticket" />
      </div>

      <PortCard />
    </div>
  );
}
